import Immutable from "immutable";
import * as types from "./constants";

const initialState = {
  siteDataFetching: false,
  siteData: []
};

const siteDataReducer = (state = Immutable.fromJS(initialState), action) => {
  switch (action.type) {
    case types.SITE_DATA_FETCH_REQUEST:
      return state.set("siteDataFetching", true);

    case types.SITE_DATA_FETCH_SUCCESS:
      return state.mergeDeep({
        siteDataFetching: false,
        siteData: action.payload
      });

    case types.SITE_DATA_FETCH_ERROR:
      return state.merge({
        siteDataFetching: false
      });

    default:
      return state;
  }
};

export default siteDataReducer;
